import React, { useEffect, useState } from "react";
import { Box, Button, Divider, FormLabel, Grid, Stack, Tooltip } from "@mui/material";
import { Lesson } from "../../types/Lessons";
import FishboneChart from "../Charts/FishboneChart";
import dayjs from "dayjs";
import ImpactChart from "../Charts/ImpactChart";
import ShareIcon from '@mui/icons-material/Share';


const Summary = (props: { lesson: Lesson, animated?: boolean, preview?: boolean } ) => {

  const animatedClass = props.animated ? "animate__animated" : ""
  const defaultWidth = props.preview ? 12 : 6

  const [copyLink, shouldCopyLink] = useState<boolean>(false);

  useEffect(() => {
    if (typeof(props.lesson) === "undefined" || !copyLink || !props.lesson.url) { return }
    navigator.clipboard.writeText(props.lesson.url);
  }, [copyLink]);

  const shareDialog = () => {
    if (typeof(props.lesson) === "undefined") { return }
    if (typeof(navigator.share) !== "undefined") {
      navigator.share({url: props.lesson.url}).then(fulfilled => {
        if (typeof(fulfilled) === "undefined") {
          shouldCopyLink(true);
        }
      }).catch(rejected => shouldCopyLink(true));
      return;
    }
  }

  return <Grid container spacing={4}>
    <Grid size={12}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <FormLabel>Lesson learned from {dayjs.unix(props.lesson.created_at).format("ll")} / Last updated: {dayjs.unix(props.lesson.updated_at).format("lll")}</FormLabel>
          <h3>{props.lesson.headline}</h3>
        </Box>

        <Tooltip 
          title={`Link copied`} 
          open={copyLink}>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              startIcon={<ShareIcon />}
              onClick={shareDialog}>Share</Button>
          </Tooltip>
      </Stack>
      <Divider sx={{mt: 1}} />
    </Grid>

    { props.lesson.summary && <Grid size={{xs: 12, md: defaultWidth}}>
      <p className={`${animatedClass} animate__fadeInUp`}><strong>Executive summary</strong></p>
      <br />
      <p>{props.lesson.summary}</p>
    </Grid> }

    { props.lesson.frequency_score && props.lesson.impact_score && <Grid size={{xs: 12, md: defaultWidth}} className={`${animatedClass} animate__fadeInUp`}>
      <p><strong>Risk score</strong></p>
      <ImpactChart set={[[props.lesson.impact_score, props.lesson.frequency_score]]} height={300} />
    </Grid> }

    { props.lesson.causes.length > 0 && <Grid size={12}>
      <p><strong>Root cause analysis</strong></p>
      <br />
      <FishboneChart {...props.lesson} />
    </Grid> }
    
  </Grid>
}

export default Summary;